import * as React from "react";
import { SVGProps } from "react";

const VSystems = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 57 45" {...props}>
    <path
      fill="#ff8836"
      fillRule="evenodd"
      d="M.51 0h16.32a.51.51 0 0 1 .25.06.5.5 0 0 1 .18.17L37.13 32a.49.49 0 0 1 0 .54L29 45.51a.5.5 0 0 1-.18.17.51.51 0 0 1-.49 0 .5.5 0 0 1-.18-.17L.08.77A.5.5 0 0 1 0 .52.5.5 0 0 1 .06.26.5.5 0 0 1 .25.07.5.5 0 0 1 .51 0Zm34.21 0h21.86a.5.5 0 0 1 .26.07.5.5 0 0 1 .16.19.51.51 0 0 1 .06.26.5.5 0 0 1-.06.25L46.08 18.21a.5.5 0 0 1-.18.17.51.51 0 0 1-.49 0 .5.5 0 0 1-.18-.17L34.3.77a.5.5 0 0 1-.08-.25.5.5 0 0 1 .06-.26.5.5 0 0 1 .19-.19.5.5 0 0 1 .25-.07Z"
    />
  </svg>
);

export default VSystems;
